import {gsap} from "gsap";

class TeamMember {

	constructor(el) {
		this.el = el;
		this.collapse = this.el.querySelector('[data-member-collapse]');
        this.image = this.el.querySelector('[data-member-image]');
		this.bio = this.el.querySelector('[data-member-bio]');
		this.toggleButtons = this.el.querySelectorAll('[data-member-toggle-bio]');

		this.imageScaleFactor = 0.3;

		// Status
		this.detailsOpen = false;
		this.animating = false;

		// Event listeners
		this.toggleButtons.forEach(button => {
			button.addEventListener('click', this.toggleDetails.bind(this));
		});


        this.init();
	}


    init() {

		if(this.image) {
			this.initialHeight = this.image.querySelector('.img').scrollHeight * this.imageScaleFactor;
		}else {
			this.initialHeight = 0;
		}

		if(this.image) {
			gsap.set(this.image, {
				scale: this.imageScaleFactor
			});
		}

        gsap.set(this.collapse, {
            height: this.initialHeight
        });

		if(this.bio) {
			gsap.set(this.bio, {
				opacity: 0
			});
		}

    }

    toggleDetails() {
		if (this.animating) {
			return;
		}

		if (this.open) {
			this.closeDetails();
		} else {
			this.openDetails();
		}
	}


    /**
	 * @param {boolean} value
	 */
	set open(value) {
		this.detailsOpen = value;

		if (value) {
			this.el.classList.add('is-expanded');
		} else {
			this.el.classList.remove('is-expanded');
		}

		this.toggleButtons.forEach(button => {
			if (this.detailsOpen) {
				button.setAttribute('aria-expanded', true);
			} else {
				button.setAttribute('aria-expanded', false);
			}
		});
	}

    get open() {
		return this.detailsOpen;
	}

	openDetails() {
		this.animating = true;
        this.open = true;

		const tl = gsap.timeline({
			onComplete: () => {
				this.animating = false;
			},
		});
		tl.to(
			this.collapse,
			{
				height: this.collapse.scrollHeight,
				ease: 'power2.inOut',
				duration: 0.3,
			}
		);
		if(this.image) {
			tl.to(
				this.image,
				{
					scale: 1,
					ease: 'power2.inOut',
					duration: 0.3,
				}, ">"
			);
		}
		if(this.bio) {
			tl.to(
				this.bio,
				{
					opacity: 1,
					ease: 'power2.inOut',
					duration: 0.3
				}, ">"
			);
		}
	}

	closeDetails() {
		this.animating = true;

		const tl = gsap.timeline({
			onComplete: () => {
				this.animating = false;
				this.open = false;
			},
		});
		if(this.bio) {
			tl.to(
				this.bio,
				{
					opacity: 0,
					ease: 'power2.inOut',
					duration: 0.3,
				}
			);
		}
		if(this.image) {
			tl.to(
				this.image,
				{
					scale: this.imageScaleFactor,
					ease: 'power2.inOut',
					duration: 0.3,
				}, ">"
			);
		}
		tl.to(
			this.collapse,
			{
				height: this.initialHeight,
				ease: 'power2.inOut',
				duration: 0.3,
			}, ">"
		);
	}
}


export default class PeopleTeam {
	constructor(el) {
		this.el = el;

        this.members = this.el.querySelectorAll('[data-person]');
        this.teamMembers = [];
        this.members.forEach(member => {
            this.teamMembers[new TeamMember(member)];
        });
	}
}